import { render, staticRenderFns } from "./AddBlockField.vue?vue&type=template&id=0d13c0be&"
import script from "./AddBlockField.vue?vue&type=script&lang=js&"
export * from "./AddBlockField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports